import React from 'react';
import { Link } from '@/components/LocaleLink';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { homeCopy } from '@/contexts/language/translations/pages/home';

const AudienceReminderSection = () => {
  const { language } = useLanguage();
  const c = homeCopy[language].reminder;

  return (
    <section className="py-12 bg-white">
      <div className="container-custom max-w-3xl mx-auto text-center">
        <p className="text-muted-foreground mb-5">{c.question}</p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/our-work/digital-cfo"
            className="inline-flex flex-col items-center px-6 py-3 rounded-full border border-[#FF6B35]/30 text-[#FF6B35] font-semibold hover:bg-[#FF6B35]/5 transition-colors"
          >
            {c.profit}
            <span className="text-xs font-normal text-[#FF6B35]/70">{c.profitSub}</span>
          </Link>
          <Link
            to="/our-work/data-engineering"
            className="inline-flex flex-col items-center px-6 py-3 rounded-full border border-[#2A1E47]/20 text-[#2A1E47] font-semibold hover:bg-[#2A1E47]/5 transition-colors"
          >
            {c.data}
            <span className="text-xs font-normal text-[#2A1E47]/60">{c.dataSub}</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AudienceReminderSection;
